import { TrustfullLabelTab, TrustfullResponse } from "shared/types/types";
import './style.scss';

import { ReactComponent as UserVerifiedIcon } from "assets/img/icons/userVerified.svg";


import React, { FC, useState } from "react";
import Tabs from "shared/ui/Tabs";
import TrustfullReasonList from "components/TrustfullReasonList";
import { motion } from "framer-motion";

import { Doughnut } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend,
} from 'chart.js';
import Button, { Button_Style } from "shared/ui/Button/Button";
import EnhancedSpeedometerTrustfull from "components/SpeedometerTrustfull/EnhancedSpeedometerTrustfull";




ChartJS.register(ArcElement, Tooltip, Legend);

type DashboardTrustfulProps = {
  trustfullData: TrustfullResponse | undefined;
  backToChoice?: () => void; // Fonction pour gérer un retour à un choix précédent
};

const DashboardTrustful: FC<DashboardTrustfulProps> = ({
   trustfullData,
   backToChoice,
                                                       }) => {
  const [reasonTab, setReasonTab] = useState(TrustfullLabelTab.TOUS);

  if (!trustfullData) {
    return <div>Aucune donnée disponible</div>;
  }

  const image = trustfullData?.phone?.whatsapp_image ?? trustfullData?.email?.avatar;
  const fullName = trustfullData?.name?.value ?? '';
  const [firstName, lastName] = fullName.split(',');
  const email = trustfullData?.email?.value ?? '';
  const phoneNumber = trustfullData?.phone?.value ?? '';
  const isPhoneConnected = (trustfullData?.phone?.status ?? '') === 'connected';
  const phoneCountry = trustfullData.phone?.country_code ?? '';
  const operateur = trustfullData.phone?.current_network ?? '';
  const isDisposable = trustfullData.phone?.is_disposable ?? false;

  const totalScore = trustfullData?.score?.score ?? 0;
  const maxScore = 1000;
  const incoherents = Math.max(0, maxScore - totalScore);
  const doughnutData = {
    labels: ['Cohérents', 'Incohérents'],
    datasets: [
      {
        label: 'Score',
        data: [totalScore/10, incoherents/10],
        backgroundColor: ['#34d399', '#f87171'], // vert et rouge
        borderColor: ['#10b981', '#ef4444'],
        borderWidth: 1,
      },
    ],
  };

  const centerTextPlugin = {
    id: 'centerText',
    beforeDraw(chart: any) {
      const { width, height, ctx } = chart;
      const score = chart.config.data.datasets[0].data[0]; // cohérents
      const maxScore = 1000;

      ctx.save();
      ctx.font = 'bold 45px sans-serif';
      ctx.fillStyle = '#374151'; // gris foncé
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(`${score}%`, width / 2, height / 2.15);
      ctx.restore();
    },
  };

  const doughnutOptions = {
    plugins: {
      legend: {
        display: true,
        position: 'bottom' as const,
      },
    },
    cutout: '70%',
    responsive: true,
    maintainAspectRatio: false,
  };


  const tabs = [
    {
      label: TrustfullLabelTab.TOUS,
      notification: false,
      content: (
          <TrustfullReasonList
              badReasons={trustfullData?.badDescriptions}
              goodReasons={trustfullData?.goodDescriptions}
          />
      ),
    },
    {
      label: TrustfullLabelTab.COHERENTS,
      notification: false,
      content: <TrustfullReasonList goodReasons={trustfullData?.goodDescriptions} />,
    },
    {
      label: TrustfullLabelTab.INCOHERENTS,
      notification: false,
      content: <TrustfullReasonList badReasons={trustfullData?.badDescriptions} />,
    },
  ];

  const handleNotification = (label: string) => {
    setReasonTab(label as TrustfullLabelTab);
  };

  const handleBack = () => {
    if (backToChoice) {
      backToChoice();
    }

  };

  return (
      <motion.div
          className="DashboardTrustful"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
      >
        <div className="d-flex gap-05 flex-row flex-wrap content__body">
          <div className="row d-flex gap-1 flex-wrap-reverse align-items-center">
            <motion.div
                className="col-sm-7"
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ delay: 0.2 }}
            >
              <motion.div className="card max-w-700" whileHover={{ scale: 1.01 }}>
                <h4>INFORMATIONS DE L'INTERLOCUTEUR</h4>
                <div className="d-flex justify-content-center flex-wrap align-items-center gap-2">
                  {(!image || image == '') && (
                      <UserVerifiedIcon
                          className="PageHeader__icon"
                          fill={"#ffeaaa"}
                      />
                  )}
                  {image && image !== '' && (
                      <img src={image} alt="photo_user" width={150} className="rounded" />
                  )}

                  <div className="d-flex flex-row gap-3 flex-wrap">
                    <div className="d-flex flex-column gap-2">
                      {lastName && (<InfoBlock label="NOM" value={lastName} />)}
                      {firstName && (<InfoBlock label="PRÉNOM" value={firstName} />)}
                      {operateur && (<InfoBlock label="OPÉRATEUR" value={operateur} />)}
                    </div>
                    <div className="d-flex flex-column gap-2">
                      {email && (<InfoBlock label="EMAIL" value={email} />)}
                      {phoneNumber && (
                        <>
                          <div>
                            <div className="bold text-sm">TÉLÉPHONE</div>
                            <div className="text-dark d-flex align-items-center gap-2 text-sm">
                              <img
                                src={`${process.env.PUBLIC_URL}/img/flags/${phoneCountry.toLowerCase()}.png`}
                                alt={phoneCountry}
                                width={20}
                                className="rounded-sm"
                              />
                              <span>{phoneNumber}</span>
                              <motion.span
                                className={`tag ${isPhoneConnected ? "tag-success" : "tag-error"}`}
                                animate={{ scale: [1, 1.1, 1] }}
                                transition={{ repeat: Infinity, duration: 1 }}
                              >
                                {isPhoneConnected ? "actif" : "inactif"}
                              </motion.span>
                            </div>
                          </div>
                          <div>
                            <div className="bold text-sm">NUMÉRO jetable</div>
                            <div className="text-sm">
                              {isDisposable ? (
                                <span className="tag tag-error">OUI</span>
                              ) : (
                                <span className="text-dark">NON</span>
                              )}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>
              </motion.div>
              <motion.div className="card max-w-700 mt-1 d-flex d-flex flex-column gap-0.5"
                          whileHover={{ scale: 1.01 }}>
                <div className="bold">RÉSULTAT DE L'ANALYSE</div>
                <div className="text-dark text-justify">
                  {totalScore >= 500 ? (
                    <p>Les informations transmises semblent cohérentes. Aucune alerte particulière n’a été détectée.</p>
                  ) : (
                    <p>Les informations analysées présentent des incohérences. ID Protect ne recommande pas d’engager une transaction avec ce contact.</p>
                  )}
                </div>
              </motion.div>
            </motion.div>
            <motion.div
              className="col-sm-3"
                  initial={{ opacity: 0, x: 20 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ delay: 0.3 }}
              >
              <motion.div className="content--card-2 center" whileHover={{ scale: 1.02 }}>
                <div className="speedometer-container">
                  <EnhancedSpeedometerTrustfull
                    score={Math.round((totalScore / maxScore) * 100)}
                    animate
                  />
                </div>
              </motion.div>
            </motion.div>
          </div>
        </div>

        <motion.div
          className="content__body"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.5 }}
        >
          <Tabs tabs={tabs} onChangeTab={handleNotification} />
          <div className="mb-1 mt-2">
            {backToChoice && (
                <Button
                    buttonType="button"
                    label="Retour"
                    style={Button_Style.OUTLINED}
                    onClick={() => handleBack()}
                />
            )}
          </div>
        </motion.div>

      </motion.div>
  );
};

const InfoBlock = ({ label, value }: { label: string; value: string }) => (
    <div>
      <div className="bold text-sm">{label}</div>
      <div className="text-dark text-sm">{value}</div>
    </div>
);

export default DashboardTrustful;
